import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';

import Select from 'components/Select';
import accountStatusFilterOptions from '../../constants/accountStatusFilterOptions';
import getBankFilterOptions from '../../utils/getBankFilterOptions';

export default class AccountsAbroadListFilters extends Component {
  static propTypes = {
    accounts: PropTypes.arrayOf(
      PropTypes.shape({
        accountContractDate: PropTypes.object,
        accountContractNumber: PropTypes.string,
        accountNumber: PropTypes.string,
        accountNumberChangeDate: PropTypes.object,
        accountNumberChanged: PropTypes.bool,
        accountType: PropTypes.string,
        accountTypeCode: PropTypes.number.isRequired,
        bankAccountTypeId: PropTypes.string,
        bankAddress: PropTypes.string,
        bankBic: PropTypes.string,
        bankDataUpdateDate: PropTypes.object,
        bankDataUpdated: PropTypes.bool.isRequired,
        bankName: PropTypes.string,
        closeDate: PropTypes.object,
        closeNotificationDate: PropTypes.object,
        closed: PropTypes.bool,
        coownersNumber: PropTypes.number,
        countryCode: PropTypes.string,
        countryId: PropTypes.number,
        countryName: PropTypes.string.isRequired,
        countryShortName: PropTypes.string.isRequired,
        openDate: PropTypes.object,
        openNotificationDate: PropTypes.object,
        pseudonym: PropTypes.string,
        recordCreateDate: PropTypes.object,
        recordUpdateDate: PropTypes.object,
        permissionDate: PropTypes.object,
        permission: PropTypes.string,
        taxpayerId: PropTypes.number.isRequired,
        updateNotificationDate: PropTypes.object,
      }),
    ),
    accountStatus: PropTypes.shape({
      filterFn: PropTypes.func,
      label: PropTypes.string,
      value: PropTypes.number,
    }),
    bank: PropTypes.shape({
      filterFn: PropTypes.func,
      label: PropTypes.string,
      value: PropTypes.number,
    }),
    setBank: PropTypes.func.isRequired,
    setAccountStatus: PropTypes.func.isRequired,
  };

  static defaultProps = {
    accounts: [],
  };

  handleBankChange = (e) => {
    const { accounts } = this.props;
    const value = e.value;
    const bankOptions = getBankFilterOptions(accounts);
    const bank = find(bankOptions, { value });

    this.props.setBank(bank);
  };

  handleAccountStatusChange = (e) => {
    const value = e.value;
    const accountStatus = find(accountStatusFilterOptions, { value });
    this.props.setAccountStatus(accountStatus);
  };

  render() {
    const { bank, accountStatus, accounts } = this.props;

    const bankOptions = getBankFilterOptions(accounts);
    const bankValue = find(bankOptions, { value: bank.value });
    const accountStatusValue = find(accountStatusFilterOptions, { value: accountStatus.value });

    return (
      <div className="cRow">
        <div className="cCol">
          <Select
            options={bankOptions}
            value={bankValue}
            className="form-select form-select__220"
            label="Наименование банка"
            onChange={this.handleBankChange}
          />
        </div>
        <div className="cCol">
          <Select
            options={accountStatusFilterOptions}
            value={accountStatusValue}
            className="form-select form-select__220"
            label="Состояние счета"
            onChange={this.handleAccountStatusChange}
          />
        </div>
      </div>
    );
  }
}
